import { DangerousTranslate } from '~/components/DangerousTranslate'
import { GT } from '~/lib/gt'

const REGULATIONS_URL = `${process.env.NEXT_PUBLIC_CZ_CLUB_URL}/regulations`

const marketingConsent = (gt: GT) => ({
  label: (
    <DangerousTranslate
      text={gt.tp(
        'RegisterForm',
        'I want to: obtain and use DISCOUNT CODES and receive information about festivals, therefore I agree to receive commercial communications from RestaurantWeek®'
      )}
    />
  ),
  showMore: (
    <DangerousTranslate
      text={gt.tp(
        'RegisterForm',
        'to the contact details I have provided and I agree to the use of these details for the purposes of direct marketing via electronic terminal devices (e-mail, online social networks, phone number provided by me - SMS, telephone contact). More information about the processing of your personal data can be found <a href="{{ regulationsLink }}" target="_blank">here</a>',
        { regulationsLink: REGULATIONS_URL }
      )}
    />
  ),
})

export const getCopy = (gt: GT) => ({
  marketingConsent: marketingConsent(gt),
})
